<template>
  <el-container class="f-h">
    <el-header class="toolbar" style="height: 3.9rem">
      <el-row type="flex" justify="space-between">
        <div class="sub-title">
          门诊号池：
          <el-dropdown type="primary" @command="command">
            <el-button type="primary" size="small">
              配置 <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-if="permission.registration_pool_globalConfig"
                command="global"
                >全局配置</el-dropdown-item
              >
              <el-dropdown-item
                v-if="permission.registration_pool_deptConfig"
                command="dept"
                >科室出勤配置</el-dropdown-item
              >
              <el-dropdown-item
                v-if="permission.registration_pool_expertConfig"
                command="expert"
                >专家出勤配置</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-button class="left-pad" type="primary" size="small" icon="el-icon-search" @click="meta.showInfo=true">就诊号列表</el-button>
        </div>
        <div>
          <el-select
            @change="target = validTargets[0]"
            v-model="regType"
            size="small"
            placeholder="号别"
            class="left-pad condition-input"
            value-key="code"
            @clear="regType = null"
          >
            <el-option
              v-for="item in validRegTypes"
              :key="item.code"
              :label="item.name"
              :value="item"
            ></el-option>
          </el-select>

          <el-select
            v-if="this.regType && this.regType.rotaType === '专家'"
            v-model="deptTarget"
            size="small"
            placeholder="科室"
            class="condition-input"
            filterable
            value-key="id"
            clearable
            @clear="deptTarget = null"
            @change="queryTargets"
          >
            <el-option
              v-for="item in deptTargets"
              :key="item.id"
              :value="item"
              :label="item.deptName"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="target"
            size="small"
            placeholder="科室或专家"
            class="condition-wide"
            filterable
            value-key="id"
            @clear="target = null"
          >
            <el-option
              v-for="item in validTargets"
              :key="item.id"
              :value="item"
              :label="item.targetType == '科室' ? item.deptName : item.doctorName"
            >
              <span v-if="item.targetType == '科室'">{{ item.deptName }}</span>
              <span v-if="item.targetType == '专家'">
                <small style="color:#BBB">{{ item.deptName }}：</small>{{ item.doctorName }}
              </span>
            </el-option>
          </el-select>

          <el-date-picker
            size="small"
            class="condition-input left-pad"
            v-model="date"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            :clearable="false"
          />
          <!-- <el-button type="default" size="mini" icon="el-icon-search" class="left-pad">检索</el-button> -->
        </div>
      </el-row>
    </el-header>
    <el-row>
      <el-col class="left" :span="12">
        <label>
          <el-button
            type="text"
            size="mini"
            icon="el-icon-d-arrow-left"
            @click="lastweek()"
            >上一周</el-button
          >
        </label>
      </el-col>
      <el-col class="right" :span="12">
        <label>
          <span style="color: #409eff; cursor: pointer"></span>
          <el-button type="text" size="mini" @click="nextweek()"
            >下一周
            <i class="el-icon-d-arrow-right" />
          </el-button>
        </label>
      </el-col>
    </el-row>
    <el-main v-if="target && regType" style="padding: 0px">
      <el-table
        class="top-pad main-table"
        height="98%"
        :highlight-current-row="true"
        :data="[
          { periodType: '上午' },
          { periodType: '下午' },
          { periodType: '夜间' }
        ]"
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{ textAlign: 'center' }"
        v-loading="meta.loading"
      >
        <el-table-column prop="periodType" width="100" label="午别" />

        <el-table-column width="150" label="时间">
          <template slot-scope="scope" class="scope">
            <tabcell isTime :spans="spans[scope.row.periodType]" />
          </template>
        </el-table-column>

        <el-table-column
          style="border:1px solid red"
          v-for="index of days"
          :key="index"
        >
          <template slot="header">
            {{ weekday(startDate, index - 1) }}<br />
            {{ monthday(startDate, index - 1) }}
            <el-button
              type="text"
              icon="el-icon-edit"
              :title="isOperDate(index) ? '不可操作' : ''"
              :disabled="isOperDate(index)"
              @click="openEditor(startDate, index - 1)"
            />
          </template>

          <template slot-scope="scope" class="scope">
            <tabcell
              ref="cell"
              :spans="spans[scope.row.periodType]"
              :targetId="target.id"
              :regTypeCode="regType.code"
              :periodType="scope.row.periodType"
              :date="monthday(startDate, index - 1)"
              :isDisDate="monthday(startDate, index)"
              :deptCode="target.deptCode"
              :doctorId="target.doctorId"
              :regData="getData(scope.row.periodType, monthday(startDate, index - 1))"
              :suspendId="getSuspendId(scope.row.periodType, monthday(startDate, index - 1))"
              @refresh="queryReg"
            />
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <setting :visible.sync="meta.showSetting" />
    <rota :isExpert="meta.isExpertRota" :visible.sync="meta.showRota"
    :target="target" :regType="regType" :deptTarget="deptTarget" />
    <editor
      :date="editDate"
      :target="target"
      :regType="regType"
      :visible.sync="meta.showEditor"
      @generated="queryReg"
    />
    <info :visible.sync="meta.showInfo" :target="target" />
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import api from "./api";
import moment from "moment";
export default {
  components: {
    setting: () => import("./setting"),
    rota: () => import("./rota"),
    editor: () => import("./editor"),
    tabcell: () => import("./_indexTabCell"),
    info: () => import("./info"),
  },
  data() {
    return {
      meta: {
        showSetting: false,
        showRota: false,
        isExpertRota: false,
        showEditor: false,
        loading: false,
        showInfo: false
      },
      target: null,
      deptTarget: null,
      regType: null,
      date: null,
      days: 7, //生成天数
      spans: { 上午: [], 下午: [], 夜间: [] },
      editDate: null,
      targetItems: null,
      regData: [],
      suspendData: []
    };
  },
  computed: {
    ...mapGetters(["dict", "permission"]),

    validRegTypes() {
      if (!this.dict.RegType) {
        return [];
      }
      return this.dict.RegType.filter(
        item => !item.disable && item.rotaType !== "急诊"
      ).sort((a, b) => {
        return a.seqNo - b.seqNo;
      });
    },

    // validRegTypes() {
    //   if (!this.dict.RegType) {
    //     return [];
    //   }
    //   if (!this.target) {
    //     return this.dict.RegType.filter(item => item.rotaType == '专家' || item.rotaType == '科室').sort((a, b) => {
    //     return a.seqNo - b.seqNo;
    //   });
    //   } else {
    //     return this.dict.RegType.filter(
    //       item =>  (this.target.targetType == item.rotaType)
    //     ).sort((a, b) => {
    //     return a.seqNo - b.seqNo;
    //   });
    //   }
    // },

    validTargets() {
      if (!this.targetItems) {
        return [];
      }
      if (!this.regType) {
        return this.targetItems.filter(item => item).sort((a, b) => {
          return a.deptCode != b.deptCode
            ? a.deptCode.localeCompare(b.deptCode)
            : (a.doctorId || 0) - (b.doctorId || 0);
        });
      } else {
        return this.targetItems.filter(
          item => item.targetType == this.regType.rotaType
        ).sort((a, b) => {
          return a.deptCode != b.deptCode
            ? a.deptCode.localeCompare(b.deptCode)
            : (a.doctorId || 0) - (b.doctorId || 0);
        });
      }
    },
    startDate() {
      let weekOfday = moment(this.date, "YYYY-MM-DD").format("E"); //计算指定日期是这周第几天
      return moment(this.date, "YYYY-MM-DD")
        .subtract(weekOfday - 1, "days")
        .format("YYYY-MM-DD"); //周一日期
    },
    deptTargets() {
      if (!this.dict.OpTarget) {
        return [];
      }
      return this.dict.OpTarget.filter(
        item => item.targetType == '科室'
      ).sort((a, b) => {
        return a.deptCode != b.deptCode
          ? a.deptCode.localeCompare(b.deptCode)
          : (a.doctorId || 0) - (b.doctorId || 0);
      });
    }
  },
  watch: {
    async startDate() {
      this.spans = { 上午: [], 下午: [], 夜间: [] };
      this.spans.上午 = await api.queryPeriodList(this.startDate, "上午");
      this.spans.下午 = await api.queryPeriodList(this.startDate, "下午");
      this.spans.夜间 = await api.queryPeriodList(this.startDate, "夜间");
      this.queryReg()
    },
    target () {
      this.queryReg()
    },
    regType () {
      this.queryReg()
    },
  },
  async created() {
    this.targetItems = this.dict.OpTarget;
    this.regType = this.validRegTypes[0];
    this.date = await this.$utils.getServerTime();
    this.target = this.validTargets[0];
  },
  methods: {
    isOperDate(index) {
      return new Date(this.monthday(this.startDate, index)) < new Date();
    },
    monthday(startDate, n) {
      return this.$utils.fmtDate(moment(startDate).add(n, "days"));
    },
    weekday(startDate, n) {
      return this.$utils.weekday(this.monthday(startDate, n));
    },
    lastweek() {
      this.date = moment(this.date)
        .add(-7, "days")
        .toDate();
    },
    nextweek() {
      this.date = moment(this.date)
        .add(7, "days")
        .toDate();
    },
    openEditor(startDate, n) {
      this.editDate = this.monthday(startDate, n);
      this.meta.showEditor = true;
    },
    refreshDay(day) {
      let cps = this.$refs.cell.filter(cp => cp.date == day);
      if (cps && cps.length) {
        cps.forEach(cp => {
          cp.refresh();
        });
      }
    },
    command(cmd) {
      if (cmd == "global") {
        this.meta.showSetting = true;
      } else if (cmd == "dept") {
        this.meta.isExpertRota = false;
        this.meta.showRota = true;
      } else if (cmd == "expert") {
        this.meta.isExpertRota = true;
        this.meta.showRota = true;
      }
    },
    queryTargets() {
      if (!this.deptTarget || !this.deptTarget.code) {
        this.targetItems = this.dict.OpTarget;
        this.target = this.validTargets[0];
        return;
      }
      const para = {
        pageSize: 99999, 
        pageIndex: 1,
        targetType: '专家',
        deptCode: this.deptTarget.code
      }
      api.queryTarget(para).then(res => {
        this.targetItems = res.items;
        this.target = this.targetItems[0];
      });
    },
    queryReg() {
      if (!this.target || !this.regType) {
        return;
      }
      this.meta.loading = true
      api.queryDoctorValidReg({
        regType: this.regType.code,
        targetId: this.target.id,
        deptCode: this.target.deptCode,
        startDate: this.startDate,
        endDate: this.monthday(this.startDate, this.days)
      }).then(res => {
        this.regData = res
        const param = {
          startDate: this.startDate,
          endDate: this.monthday(this.startDate, this.days),
          targetId: this.target.id,
          regType: this.regType.code,
          deptCode: this.target.deptCode,
        }
        return api.querySuspend(param)
      }).then(res => {
        this.suspendData = res.items
      }).catch(err => {
        this.$message.error(err.message || err)
      }).finally(() => {
        this.meta.loading = false
      })
    },
    getData(periodType, date) {
      return this.regData.filter(t => t.periodType === periodType && t.date === date)
    },
    getSuspendId(periodType, date) {
      const items = this.suspendData.filter(t => t.periodType === periodType && t.date === date)
      return items.length > 0 ? items[0].id : null
    },
  }
};
</script>
